export default __webpack_public_path__ + "static/media/Arrow Right - White.89b143fe.svg";